import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
})
export class TimeFormatPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    return value.split(':')[0] + ':' + value.split(':')[1];
  }
}
